<h1 class="cg-h1">View and Submit Precertifications</h1>

<p>
  Effective January 1, 2022, NaviNet is no longer available for online
  precertification submissions for your patients with commercial Cigna coverage.
  All precertification capabilities on NaviNet, including precertification
  Inquiry, have been retired. Visit the
  <a
    href="https://static.cigna.com/assets/chcp/resourceLibrary/preCertification/preCertification.html"
    target="_blank"
    >Precertification Resource page
  </a>
  for more information regarding other precertification options or call
  800.88Cigna (800.882.4462) for questions or to initiate a precertification
  request.
</p>

<div class="cg-button-group cg-margin-top-xl">
  <a type="link" (click)="goToPreviousPage()"> Back </a>
</div>
